<template>
	<div>
		<div class="data44">
			<div class="data44Til">
				多功能集成·体验再升维
			</div>
			<div class="data44Box">
				<div class="swiper-hexinTwo">
					<div class="swiper-wrapper">
						<div class="swiper-slide swiper-slideTwo" v-for="(itema,indexa) in list" :key="indexa">
							<div class="swiper-slideTwo-img">
								<img :src="itema.img" />
							</div>
							<div class="swiper-slideTwo-imgTwo">
								<img  :src="itema.imgTwo" />
							</div>
							<div class="swiper-slideTwo-name">
								{{itema.name}}
							</div>
							<div class="swiper-slideTwo-cen">
								{{itema.cen}}
							</div>
						</div>
					</div>
					<div class="swiper-hexin-prev" :style="{
					display:prev
				}">
						<img src="@/assets/product/page6/zjt.png" />
					</div>
					<div class="swiper-hexin-next" :style="{
					display:next
				}">
						<img src="@/assets/product/page6/yjt.png" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		data() {
			return {
				list: [{
						img: require("@/assets/content/hexinBanner.png"),
						imgTwo: require("@/assets/product/page11/tbcd.png"),
						name: '同步传导',
						cen: '结肠镜插入部的惯性设计将手柄处操作者的推拉力和旋转力传递到结肠镜的先端部，能够帮助医生更好地进镜到盲肠'
					},
					{
						img: require("@/assets/content/hexinBanner.png"),
						imgTwo: require("@/assets/product/page11/rykt.png"),
						name: '软硬可调',
						cen: '结肠镜插入管具有多级软硬度调整功能，通过旋转调节环可改变插入部的软硬度，可满足结肠不同部位的进镜需求'
					},
					{
						img: require("@/assets/content/hexinBanner.png"),
						imgTwo: require("@/assets/product/page11/rykt.png"),
						name: '随动弯曲',
						cen: '可顺应结肠不同部位的转向，在脾曲肝曲等部位'
					},
					{
						img: require("@/assets/content/hexinBanner.png"),
						imgTwo: require("@/assets/product/page11/zmxt.png"),
						name: '头端3光窗照明系统',
						cen: '- 提供角度更大、更均匀的照明效果- 与大视场角结合可得到更好的图像效果'
					},
					{
						img: require("@/assets/content/hexinBanner.png"),
						imgTwo: require("@/assets/product/page11/fss.png"),
						name: '副送水',
						cen: '- AQ-300系列全线内镜均配备前向副送水功能- 帮助在诊断和治疗过程中实时保持视野清晰，快速发现出血点'
					},
				],
				mySwiper: "",
				sliact: 0,
				prev: 'none',
				next: 'block'
			}
		},
		mounted() {
			let t = this;

			this.mySwiper = new this.$swiper('.swiper-hexinTwo', {
				// 内部Swiper的选项
				direction: 'horizontal',
				widch: 580,
				slidesPerView: 2.3, // 每屏显示3个滑块
				slidesPerGroup: 1, // 每次滑动3个滑块
				spaceBetween: 40,
				slidesOffsetBefore: 250,
				slidesOffsetAfter: 250,
				autoplay:false,
				// 自动播放
				// autoplay: {
				// 	delay: 3000,
				// 	disableOnInteraction: false,
				// },
				navigation: {
					prevEl: ".swiper-hexin-prev",
					nextEl: ".swiper-hexin-next",
				},
				on: {
					slideChangeTransitionEnd: function() {
						if (this.activeIndex === 0) {
							t.prev = 'none';
						} else {
							t.prev = 'block';
						}
						if (this.activeIndex === this.slides.length - 1) {
							t.next = 'none';
						} else {
							t.next = 'block';
						}
						if (this.activeIndex === this.slides.length - 2) {
							t.next = 'none';
						} else {
							t.next = 'block';
						}
						// if (t.sliact == this.activeIndex && t.sliact == this.slides.length - 2) {
						// 	t.next = 'none';
						// } else {
						// 	t.sliact = this.activeIndex;
						// }
					},
				},
			});
		},
		methods: {

		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.swiper-hexin {
		overflow: hidden;
	}

	.swiper-hexinTwo {
		overflow: hidden;
		position: relative;

		.swiper-hexin-prev {
			position: absolute;
			top: 50%;
			left: 260px;
			z-index: 99;
			width: 51px;
			height: 51px;

			img {
				width: 51px;
				height: 51px;
			}

			border-radius: 100%;
			transform: translateY(-50%);
			transition: all 0.3s ease;

		}

		.swiper-hexin-next {
			transform: translateY(-50%);
			position: absolute;
			top: 50%;
			right: 260px;
			z-index: 99;
			width: 51px;
			height: 51px;
			border-radius: 100%;
			transition: all 0.3s ease;

			img {
				width: 51px;
				height: 51px;
			}
		}
	}

	.swiper-slideTwo {
		position: relative;

		// width: 580px;
		.swiper-slideTwo-img {
			// width: 580px;
			height: 440px;
			margin-bottom: 36px;
		
			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
		.swiper-slideTwo-imgTwo{
			width:70px;
			height: 70px;
			margin-bottom: 40px;
			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}
		.swiper-slideTwo-name {
			font-size: 26px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #000000;
			margin-bottom: 32px;
		}

		.swiper-slideTwo-cen {
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #000000;
		}
	}

	.data44 {
		padding-bottom: 150px;

		.data44Til {
			padding-left: 250px;
			font-size: 45px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 62px;
		}

		.data44Cen {
			padding-left: 250px;
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #000000;
			margin-bottom: 65px;
			width: 770px;
		}

		.data44Img {
			padding-left: 250px;
			width: 100%;
			height: 600px;
			box-sizing: border-box;
			margin-bottom: 40px;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		.data44Box {}
	}
</style>